import { EditorView } from '@codemirror/view';
import { type RefObject } from 'react';

/**
 * Configures the spellcheck functionality on the editor.
 * @param spellCheck - flag pointing to whether spellcheck is enabled or not
 * @param readOnly - flag pointing to whether the editor is in readonly mode or not
 * @param viewRef - Ref object for the editor
 */
export const configureSpellCheck = (
  spellCheck: boolean,
  readOnly: boolean,
  viewRef: RefObject<EditorView>,
): void => {
  if (readOnly) {
    viewRef.current.contentDOM.setAttribute('spellcheck', 'false');
    viewRef.current.contentDOM.spellcheck = false;
  } else {
    viewRef.current.contentDOM.spellcheck = spellCheck;
    viewRef.current.contentDOM.setAttribute(
      'spellcheck',
      spellCheck ? 'true' : 'false',
    );
  }
};
